import NormalLogo from "@/assets/img/logo.png";
import classNames from "classnames";
import { FC } from "react";
import { Link } from "react-router-dom";
import PoweredBy from "./PoweredBy";

interface IProps {
  at?: "navbar-vertical" | "navbar-top" | "auth";
  className?: string;
}

const Logo: FC<IProps> = ({ at = "navbar-vertical", className }) => {
  return (
    <Link to="/" className="navbar-brand text-left text-decoration-none">
      <div
        className={classNames(
          "d-flex align-items-center",
          {
            "align-items-center py-3": at === "navbar-vertical",
            "align-items-center": at === "navbar-top",
            "flex-center fw-bolder fs-5 mb-4": at === "auth",
          },
          className
        )}
      >
        <img
          className="ms-1 me-2"
          src={NormalLogo}
          alt="Logo Formalys"
          width={40}
        />
        {at === "navbar-vertical" && (
          <span className="d-flex flex-column lh-sm text-start">
            <span className="font-sans-serif formalys-brand-name">Formalys</span>
            <PoweredBy />
          </span>
        )}
      </div>
    </Link>
  );
};

export default Logo;
